import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=cd6293d2&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=ts"
export * from "./BannerSwiper.vue?vue&type=script&lang=ts"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=cd6293d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6293d2",
  null
  
)

export default component.exports